export const setDropTrailerStatus = ({ deliveries, info: { dropTrailer }, pickups }) => {
  const [pickup] = pickups
  const [delivery] = deliveries

  if (pickup.isDropTrailer || delivery.isDropTrailer)
    return { pickup: pickup.isDropTrailer, delivery: delivery.isDropTrailer }

  const result = {}
  const stops = ['pickup', 'delivery']

  stops.forEach(stop => {
    result[stop] = dropTrailer
  })

  return result
}
